import { FallbackPriceTierOut, ProductOut } from '../../store/api';
import { globalErrorResponse, showNotification, TYPE_WARNING } from '../../store/notifications/actions';
import { failSelectionlists, fetchSelectionlists } from '../../store/orderlist/actions';
import { AppDispatch } from '../../store';
import { TFunction } from 'i18next';
import { ADD_TO_LIST } from '../../store/orderlist/types';

type Params<T> = {
    performChecks: boolean;
    dispatch: AppDispatch;
    setLoading: (loading: boolean) => void;
    notificationMessage?: string | ((responseData: T) => string);
    apiCallback: () => Promise<T>;
    t: TFunction;
    onSuccess: () => void;
};

interface ResponseType {
    readonly fallbackPriceTiers?: ReadonlyArray<FallbackPriceTierOut>;
    readonly alreadyInListProducts?: Array<ProductOut>;
    readonly hasEpress?: boolean;
}

export function bulkUpdateToList<T extends ResponseType>({
    performChecks,
    dispatch,
    setLoading,
    notificationMessage,
    apiCallback,
    t,
    onSuccess
}: Params<T>): Promise<T> {
    setLoading(true);

    // this is responsible for the list total animation
    dispatch({ type: ADD_TO_LIST });

    return apiCallback()
        .then(data => {
            const alreadyInListProducts = data.alreadyInListProducts ?? [];
            const fallbackPriceTiers = data.fallbackPriceTiers ?? [];

            if (fallbackPriceTiers.length === 0 && alreadyInListProducts.length === 0) {
                const message =
                    typeof notificationMessage === 'function' ? notificationMessage(data) : notificationMessage;


                if (data.hasEpress) {
                    dispatch(showNotification(t('notifications.hasEpress', { context: 'list' }), TYPE_WARNING));
                }
                dispatch(showNotification(message ?? t('notifications.addToListBulk.success')));
                dispatch(fetchSelectionlists());

                onSuccess();
            }
            return data;
        })
        .catch(error => {
            if (!performChecks) {
                dispatch(failSelectionlists(error));
            } else {
                dispatch(globalErrorResponse(error));
            }
            return Promise.reject(error);
        })
        .finally(() => setLoading(false));
}
